import React, { useState } from 'react';
import { PolicyModal } from './PolicyModal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const getRecentDate = () => {
    const now = new Date();
    now.setMonth(now.getMonth() - 2);
    return now.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  };
  return <>
      <footer className="bg-brown-900 py-6 text-center" data-id="element-106">
        <div className="max-w-2xl mx-auto px-6" data-id="element-107">
          <p className="text-xs leading-relaxed text-cream-200/50" data-id="element-108">
            &copy; 2026 Stop Overpaying Medical Bills. All rights reserved. This
            educational resource is not affiliated with or endorsed by Facebook
            and does not constitute legal, medical, or financial advice. Results
            vary; consult a qualified professional. By using this site you agree
            to our{' '}
            <button onClick={() => setActiveModal('privacy')} className="text-terracotta-400/60 hover:text-terracotta-400 underline underline-offset-2 transition-colors" data-id="element-109">
              Privacy Policy
            </button>{' '}
            &amp;{' '}
            <button onClick={() => setActiveModal('terms')} className="text-terracotta-400/60 hover:text-terracotta-400 underline underline-offset-2 transition-colors" data-id="element-110">
              Terms of Service
            </button>
            .
          </p>
        </div>
      </footer>

      <PolicyModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Privacy Policy" data-id="element-111">
        <h3 className="font-serif font-bold text-brown-900 text-base mt-4" data-id="element-112">
          1. Information We Collect
        </h3>
        <p data-id="element-113">
          When you purchase or download our digital products, we collect only
          the information necessary to process your order, including your name
          and email address. We do not collect sensitive personal data beyond
          what is required for the transaction.
        </p>

        <h3 className="font-serif font-bold text-brown-900 text-base mt-4" data-id="element-114">
          2. How We Use Your Information
        </h3>
        <p data-id="element-115">
          Your information is used solely to deliver the digital product you
          purchased, send order confirmations and access instructions, and
          provide customer support related to your purchase. We do not sell,
          rent, or share your personal information with third parties for
          marketing purposes.
        </p>

        <h3 className="font-serif font-bold text-brown-900 text-base mt-4" data-id="element-116">
          3. Data Security
        </h3>
        <p data-id="element-117">
          We implement industry-standard security measures to protect your
          personal information. All transactions are processed through secure,
          encrypted connections. However, no method of electronic transmission
          is 100% secure, and we cannot guarantee absolute security.
        </p>

        <h3 className="font-serif font-bold text-brown-900 text-base mt-4" data-id="element-118">
          4. Cookies
        </h3>
        <p data-id="element-119">
          Our website may use essential cookies to ensure proper functionality.
          We do not use tracking cookies for advertising purposes. You can
          control cookie settings through your browser preferences.
        </p>

        <h3 className="font-serif font-bold text-brown-900 text-base mt-4" data-id="element-120">
          5. Your Rights
        </h3>
        <p data-id="element-121">
          You have the right to access, correct, or request deletion of your
          personal data at any time. You may also opt out of any marketing
          communications we send.
        </p>

        <h3 className="font-serif font-bold text-brown-900 text-base mt-4" data-id="element-122">
          6. Changes to This Policy
        </h3>
        <p data-id="element-123">
          We may update this Privacy Policy from time to time. Any changes will
          be posted on this page with an updated revision date. Your continued
          use of our products and services constitutes acceptance of the updated
          policy.
        </p>

        <p className="text-brown-400 text-xs uppercase tracking-wider mt-6 pt-4 border-t border-cream-200 text-center" data-id="element-124">
          Last updated: {getRecentDate()}
        </p>
      </PolicyModal>

      <PolicyModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Terms of Service" data-id="element-125">
        <h3 className="font-serif font-bold text-brown-900 text-base mt-4" data-id="element-126">
          1. Digital Product License
        </h3>
        <p data-id="element-127">
          Upon purchase, you are granted a personal, non-transferable,
          non-exclusive license to use the digital content in "Stop Overpaying
          Medical Bills" for your own personal and household use. You may not
          redistribute, resell, or share the content with others.
        </p>

        <h3 className="font-serif font-bold text-brown-900 text-base mt-4" data-id="element-128">
          2. Educational Disclaimer
        </h3>
        <p data-id="element-129">
          The content provided in this product is for educational and
          informational purposes only. It does not constitute legal, financial,
          or medical advice. Results may vary based on individual circumstances,
          healthcare providers, and billing situations. We make no guarantees
          regarding specific savings amounts or outcomes.
        </p>

        <h3 className="font-serif font-bold text-brown-900 text-base mt-4" data-id="element-130">
          3. Intellectual Property
        </h3>
        <p data-id="element-131">
          All content, templates, scripts, checklists, and materials included in
          this product are protected by copyright. Unauthorized reproduction,
          distribution, or modification of any materials is strictly prohibited.
        </p>

        <h3 className="font-serif font-bold text-brown-900 text-base mt-4" data-id="element-132">
          4. Refund Policy
        </h3>
        <p data-id="element-133">
          Due to the digital nature of this product, all sales are final once
          the content has been accessed or downloaded. If you experience
          technical issues accessing your purchase, please reach out and we will
          work to resolve the issue promptly.
        </p>

        <h3 className="font-serif font-bold text-brown-900 text-base mt-4" data-id="element-134">
          5. Limitation of Liability
        </h3>
        <p data-id="element-135">
          We shall not be held liable for any direct, indirect, incidental, or
          consequential damages arising from the use or inability to use the
          information provided in this product. You acknowledge that you are
          solely responsible for any actions taken based on the content.
        </p>

        <h3 className="font-serif font-bold text-brown-900 text-base mt-4" data-id="element-136">
          6. Modifications
        </h3>
        <p data-id="element-137">
          We reserve the right to modify these Terms of Service at any time.
          Changes will be effective immediately upon posting. Your continued use
          of the product after changes constitutes acceptance of the revised
          terms.
        </p>

        <p className="text-brown-400 text-xs uppercase tracking-wider mt-6 pt-4 border-t border-cream-200 text-center" data-id="element-138">
          Last updated: {getRecentDate()}
        </p>
      </PolicyModal>
    </>;
}